module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/icon_efo-b96bc2e25c827882697768afd5d52e4b.svg";